import { composeReducers } from "../../common";
import { initialCameraState } from "../camera.state";
import { ruleReducer } from "./rule.reducer";
import { cameraReducer } from "./camera.reducers";
import { scheduleReducer } from "./schedule.reducer";

export const sensorReducer = composeReducers(initialCameraState, cameraReducer, ruleReducer, scheduleReducer);
